import * as graphql from 'generated/graphql';
import useLocalize from 'packages/kakapo-ui-application/hooks/useLocalize';
import QuillEditor from 'packages/kakapo-ui-kit/components/editors/QuillEditor';

export default function Paragraph(props: {
	item: graphql.EvaluationParagraphItem;
	readonly?: boolean;
}) {
	const { localize } = useLocalize();

	return <QuillEditor value={localize(props.item.text).text} inline readOnly />;
}
